import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import { Route } from 'react-router';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import createHistory from 'history/createBrowserHistory';
import './index.css';
import App from './App';
import { About } from './containers/About';
import registerServiceWorker from './registerServiceWorker';
import allReducers from './reducers';
// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory();

// Build the middleware for intercepting and dispatching navigation actions
const middleware = routerMiddleware(history);


injectTapEventPlugin();

// Add the reducer to your store on the `router` key
// Also apply our middleware for navigating

export const store = createStore(
  allReducers,
  applyMiddleware(middleware),
);



ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider >
      <ConnectedRouter history={history}>
        <div>
          <Route path="/about" component={About} />
          <Route path="/prozesskostenrechner/" component={ App } />
          <Route path="/anwaltskostenrechner/" component={ App } />
          <Route path="/verzugszinsen-berechnen" component={() => window.location = 'https://www.prinz.law/verzugszinsen-berechnen/'}/>
          <Route exact path="/" component={() => window.location = 'https://www.prinz.law/'}/>
        
        </div>
      </ConnectedRouter>
    </MuiThemeProvider>
  </Provider>, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js